import * as Joi from "joi";
import { LEAD_FIELD_LIMITS } from "../../../../types/LeadTypes";

export const leadIdentitySchema = {
  first_name: Joi.string()
    .trim()
    .max(LEAD_FIELD_LIMITS.first_name.max)
    .allow("")
    .label("First name"),
  last_name: Joi.string()
    .trim()
    .max(LEAD_FIELD_LIMITS.last_name.max)
    .allow("")
    .label("Last name"),
  email: Joi.string()
    .trim()
    .max(LEAD_FIELD_LIMITS.email.max)
    .allow("")
    .label("Email"),
  phone: Joi.string().allow("", null),
};
